







































import {Component, Vue} from "vue-property-decorator";
import DataTable, { ColumnMetaData } from "xl2sql/dist/dataTable";
import FileInput from 'xl2sql/dist/fileInput';
import TableParser from 'xl2sql/dist/tableParser';

@Component({
    name: 'Xl2Sql'
})
export default class Xl2Sql extends Vue {

    input!: FileInput;
    error: string | null = null;
    datatable: DataTable | null = null;
    header: {[key: string]: ColumnMetaData} = {};
    
    mounted() {
        this.input = FileInput.generate(document.getElementById('uploader') as HTMLElement);
        this.input.onUpload(async (file) => {
            this.error = null;
            this.header = {};
            this.datatable = null;
            try {
                this.datatable = await TableParser.parseFile(file);
                
                for (const col of this.datatable.header) {
                    const info = this.datatable.getColumnInfo(col);
                    this.header[col] = info;
                }

                this.$nextTick(() => {
                    // @ts-ignore
                    document.getElementById('datatable').appendChild(this.datatable.getHtml());
                })
            } catch(e) {
                this.error = e.message
            }
        })
    }
}

